import { up, down } from 'slide-element';
import { enableBodyScroll } from 'body-scroll-lock';
import announcer from './aria-announcer';

document.addEventListener('DOMContentLoaded', () => {
    const $contentPage = document.querySelector('.content-page.section');
    const $toggleBtn = document.querySelector('.btn-aside-mobile');
    const $nav = document.querySelector('.content-aside');
    if (!$contentPage) return;

    const headings = document.querySelectorAll('.article-body h2, .article-body h3, .article-body h4');
    if ($contentPage && ($contentPage.classList.contains('section') || $contentPage.classList.contains('article'))) {
        if (!headings.length) {
            const contentAside = document.querySelector('.content-left-col');
            if (contentAside) contentAside.style.display = 'none';
            return;
        }
    }

    const $navList = document.querySelector('.content-aside-nav');
    if (!$navList) return;

    let lastH2Li = null;
    let lastH3Li = null;

    function closeMenus(activeLink) {
        const parentLis = [];
        let current = activeLink.closest('li');
        while (current && current.parentElement) {
            parentLis.push(current);
            const parentUl = current.parentElement;
            if (parentUl === $navList) break;
            current = parentUl.closest('li');
        }

        $navList.querySelectorAll('button[aria-expanded="true"]').forEach((openButton) => {
            const wrapperDiv = openButton.parentElement;
            const buttonLi = wrapperDiv.closest('li');

            if (!parentLis.includes(buttonLi)) {
                openButton.setAttribute('aria-expanded', 'false');
                const ul = wrapperDiv.nextElementSibling;
                if (ul && ul.tagName === 'UL') {
                    ul.setAttribute('aria-hidden', 'true');
                    up(ul);
                }
            }
        });
    }

    function closeSiblingMenus(wrapperDiv) {
        const parentUl = wrapperDiv.parentElement;
        if (!parentUl) return;
        parentUl.querySelectorAll(':scope > li > .content-aside-nav-trigger > button[aria-expanded="true"]').forEach((openButton) => {
            if (openButton !== wrapperDiv.querySelector('button')) {
                openButton.setAttribute('aria-expanded', 'false');
                const ul = openButton.parentElement.nextElementSibling;
                if (ul && ul.tagName === 'UL') {
                    ul.setAttribute('aria-hidden', 'true');
                    up(ul);
                }
            }
        });
    }

    function ensureVisible(link) {
        link.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    let activeH2Id = null;

    headings.forEach((heading) => {
        const parentWithId = heading.closest('[id]');
        if (!parentWithId) return;

        const li = document.createElement('li');
        const link = document.createElement('a');

        link.href = `#${parentWithId.id}`;
        link.innerHTML = `
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.98685 0.639137C8.17241 0.453574 8.4733 0.453668 8.65893 0.639137L11.6837 3.66396C11.8694 3.84957 11.8694 4.15043 11.6837 4.33604L8.65893 7.36086C8.4733 7.54633 8.17241 7.54643 7.98685 7.36086C7.80128 7.1753 7.80138 6.8744 7.98685 6.68878L10.2003 4.47528H-0.059082V3.52472H10.2003L7.98685 1.31122C7.80138 1.1256 7.80128 0.824699 7.98685 0.639137Z" fill="#000000"/>
            </svg>
            <span>${heading.textContent.trim()}</span>
        `;

        li.appendChild(link);

        if (heading.tagName === 'H2') {
            $navList.appendChild(li);
            lastH2Li = li;
            lastH3Li = null;
        } else if (heading.tagName === 'H3') {
            if (!lastH2Li) return;
            let sublist = lastH2Li.querySelector('ul.second-level-nav');
            if (!sublist) {
                sublist = document.createElement('ul');
                sublist.classList.add('second-level-nav');
                lastH2Li.appendChild(sublist);
            }
            sublist.appendChild(li);
            lastH3Li = li;
        } else if (heading.tagName === 'H4') {
            if (!lastH3Li) return;
            let sublist = lastH3Li.querySelector('ul.third-level-nav');
            if (!sublist) {
                sublist = document.createElement('ul');
                sublist.classList.add('third-level-nav');
                lastH3Li.appendChild(sublist);
            }
            sublist.appendChild(li);
        }
    });

    $navList.querySelectorAll('li > a').forEach((link) => {
        const nextUl = link.nextElementSibling;
        if (nextUl && nextUl.tagName === 'UL') {
            const wrapperDiv = document.createElement('div');
            wrapperDiv.className = 'content-aside-nav-trigger';

            const collapseButton = document.createElement('button');
            collapseButton.setAttribute('type', 'button');
            collapseButton.setAttribute('aria-expanded', 'false');
            collapseButton.innerHTML = `
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 5.96942C8.01431 5.96946 8.01997 5.97171 8.02148 5.97235C8.02382 5.97336 8.03271 5.97773 8.04785 5.99286L11.3438 9.28876C11.3597 9.30476 11.3644 9.31416 11.3652 9.3161C11.3656 9.31703 11.3672 9.32161 11.3672 9.33368C11.3671 9.34541 11.3656 9.34937 11.3652 9.35028C11.3645 9.35196 11.3601 9.3613 11.3438 9.37762C11.3289 9.39246 11.3198 9.39616 11.3174 9.39716C11.3148 9.39819 11.3076 9.40106 11.291 9.40106C11.2739 9.40103 11.2668 9.39808 11.2646 9.39716C11.2621 9.39609 11.253 9.39233 11.2383 9.37762L11.2373 9.37665L8.35254 6.50751L7.99902 6.15594L4.76074 9.39423C4.75291 9.40206 4.74699 9.40596 4.74414 9.4079C4.74242 9.40906 4.74153 9.40969 4.74121 9.40985H4.73438C4.71613 9.40917 4.70117 9.40692 4.67188 9.37762C4.65695 9.3627 4.65334 9.35364 4.65234 9.35126C4.65136 9.34889 4.64844 9.34184 4.64844 9.32489C4.64844 9.30783 4.65138 9.30083 4.65234 9.29852C4.65334 9.29614 4.65694 9.28709 4.67188 9.27216L7.95117 5.99286C7.96696 5.97707 7.97663 5.97315 7.97852 5.97235C7.98051 5.97154 7.98651 5.96942 8 5.96942Z" fill="#191919" stroke="#191919"/>
                </svg>
            `;

            link.parentNode.insertBefore(wrapperDiv, link);
            wrapperDiv.appendChild(link);
            wrapperDiv.appendChild(collapseButton);

            nextUl.setAttribute('aria-hidden', 'true');
            up(nextUl);

            collapseButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const siblingUl = wrapperDiv.nextElementSibling;
                if (siblingUl && siblingUl.tagName === 'UL') {
                    const isExpanded = collapseButton.getAttribute('aria-expanded') === 'true';
                    if (isExpanded) {
                        collapseButton.setAttribute('aria-expanded', 'false');
                        siblingUl.setAttribute('aria-hidden', 'true');
                        up(siblingUl);
                        announcer.announce(`Le menu ${link.textContent.trim()} est fermé`);
                    } else {
                        closeSiblingMenus(wrapperDiv);
                        collapseButton.setAttribute('aria-expanded', 'true');
                        siblingUl.setAttribute('aria-hidden', 'false');
                        down(siblingUl);
                        announcer.announce(`Le menu ${link.textContent.trim()} est ouvert`);
                    }
                }
            });

            link.addEventListener('click', (e) => {
                const href = link.getAttribute('href');
                if (href && href.startsWith('#')) {
                    e.preventDefault();
                    const target = document.querySelector(href);
                    if (target) target.scrollIntoView({ behavior: 'smooth' });

                    $navList.querySelectorAll('a.active').forEach((activeLink) => {
                        activeLink.classList.remove('active');
                    });

                    link.classList.add('active');

                    const targetId = href.slice(1);
                    if (link.closest('li').parentElement === $navList) {
                        activeH2Id = targetId;
                    }

                    closeMenus(link);

                    const submenu = wrapperDiv.nextElementSibling;
                    if (submenu && submenu.tagName === 'UL') {
                        collapseButton.setAttribute('aria-expanded', 'true');
                        submenu.setAttribute('aria-hidden', 'false');
                        down(submenu);
                    }

                    ensureVisible(link);
                }
            });
        } else {
            link.addEventListener('click', (e) => {
                const href = link.getAttribute('href');
                if (href && href.startsWith('#')) {
                    e.preventDefault();
                    const target = document.querySelector(href);
                    if (target) target.scrollIntoView({ behavior: 'smooth' });

                    $navList.querySelectorAll('a.active').forEach((activeLink) => {
                        activeLink.classList.remove('active');
                    });

                    link.classList.add('active');

                    const targetId = href.slice(1);
                    if (link.closest('li').parentElement === $navList) {
                        activeH2Id = targetId;
                    }

                    closeMenus(link);
                    ensureVisible(link);
                }
            });
        }
    });

    const h2IdToLink = new Map();
    const h2Headings = document.querySelectorAll('.article-body h2');
    h2Headings.forEach((h2) => {
        const parentWithId = h2.closest('[id]');
        if (!parentWithId) return;
        const { id } = parentWithId;
        const link = $navList.querySelector(`a[href="#${id}"]`);
        if (link && link.closest('li').parentElement === $navList) {
            h2IdToLink.set(id, link);
        }
    });

    const h2Observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((e) => e.isIntersecting);
        if (visible.length > 0) {
            visible.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
            const topH2 = visible[0].target;
            const parentId = topH2.closest('[id]')?.id;
            if (parentId && activeH2Id !== parentId && h2IdToLink.has(parentId)) {
                if (activeH2Id && h2IdToLink.has(activeH2Id)) {
                    h2IdToLink.get(activeH2Id).classList.remove('active');
                }
                h2IdToLink.get(parentId).classList.add('active');
                activeH2Id = parentId;
            }
        }
    }, { root: null, rootMargin: '0px 0px 0px 0px', threshold: [0, 0.25, 0.5, 0.75, 1] });

    h2Headings.forEach((h2) => {
        const parentWithId = h2.closest('[id]');
        if (parentWithId) h2Observer.observe(h2);
    });

    $navList.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener('click', () => {
            if (window.innerWidth <= 768) {
                $toggleBtn.setAttribute('aria-expanded', 'false');
                $nav.classList.remove('active');
                enableBodyScroll($nav);
                announcer.announce('Le menu est fermé');
            }
        });
    });
});
